export const RETURNGOODSLIST_SUCCESS = "RETURNGOODSLIST_SUCCESS";
export const SETRETURNGOOD = "RETURNGOOD"; 
